import { getDeviceInfo, } from '@office-start/device-detection-utility';
// Events added later will be executed first (Stack). To attempt executing later pass lateExecution = true.
// Note we only guarantee that all 'lateExecution' actions will execute after all non-'lateExecution' actions
export function addUnloadEvent(eventAction, lateExecution) {
    if (lateExecution === void 0) { lateExecution = false; }
    // only call it once across any events
    var called = false;
    var executeNewAndOld = function (ev, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    oldAction) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var returnValue = undefined;
        if (lateExecution && oldAction) {
            returnValue = oldAction(ev);
        }
        if (!called) {
            called = true;
            eventAction();
        }
        if (!lateExecution && oldAction) {
            returnValue = oldAction(ev);
        }
        // IMPORTANT: Return 'undefined' in case oldOnbeforeunload is null.
        // Returning null in IE11 triggers showing "Do you want to leave this page" dialog
        // with 'null' displayed as message text.
        return returnValue;
    };
    // most browsers support onbeforeunload, use that first
    var oldOnbeforeunload = window.onbeforeunload;
    window.onbeforeunload = function (ev) {
        return executeNewAndOld(ev, oldOnbeforeunload && oldOnbeforeunload.bind(window));
    };
    var deviceInfo = getDeviceInfo();
    var platformType = deviceInfo.platform.platformType;
    var handlePageHide = (platformType === "iPhone" /* iPhone */ ||
        platformType === "iPad" /* iPad */) &&
        deviceInfo.browser.browserType === "Safari" /* Safari */;
    // Some browsers support pagehide
    if (handlePageHide) {
        var oldPageHide_1 = window.onpagehide;
        window.onpagehide = function (ev) {
            return executeNewAndOld(ev, oldPageHide_1 && oldPageHide_1.bind(window));
        };
    }
}
//# sourceMappingURL=addUnloadEvent.js.map